module.exports = __webpack_public_path__ + "static/img/selfie-icon.a4e6ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/selfie-icon.png
// module id = C7vo
// module chunks = 36